//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        value: {
            type: Boolean,
            defalut: false
        },
        showClose: {
            type: Boolean,
            default: true
        }
    }
};
